<template>
  <div class="subheader">
    <ods-sub-header :is-absolute="false">
        <div class="toolbar">
          <div class="toolbar__section">
            <form-filter v-if="dynFilters.length > 0" :filters="dynFilters" :dashboardId="dashboardId"></form-filter>
            <div v-if="this.dynFilters.length == 0">{{$t('filters.noFilters')}}</div>
          </div>
        </div>
        <template slot="ctas">
          <div class="toolbar__section" v-if="isFavoritesEnabled">
            <!-- search gadgets and dashboards -->
            <ods-tooltip :effect="'dark'" :content="$t('filters.search')" :placement="'top'" :offset="-130">
              <ods-input-search ref="searchBtn" v-model="query" :size="'mega'" :placeholder="$t('filters.search')" :expandableSearch="true" :clearable="true" :icon="searchIcon" @search="handleSearch"></ods-input-search>
            </ods-tooltip>
            <ods-tooltip  :content="$t('filters.save_dashboard')" :placement="'left'">
              <ods-button :title="$t('filters.save_dashboard')" v-if="dashboardId" @click="saveDashboard" type="neutral" :text="$t('filters.save_dashboard')"  :iconPosition="'right'" :icon="'ods-icon-save'" :size="'medium'" :nativeType="'text'"></ods-button>
            </ods-tooltip>
          </div>
        </template>
    </ods-sub-header>
    <ods-module v-if="searchResults" class="search-results" :header="'Resultados de la Búsqueda:'" :shadow="'always'" v-click-outside="closeResults">
        <div style="margin-bottom: 20px">
          <div v-if="searchTotalResults === 0">{{$t('filters.search_NoResults')}}</div>
          <ods-table :data="searchItems" :border="false" :stripe="false" :size="'medium'" :fit="true"  height="300"  :emptyText="$t('filters.search_NoResults')" @row-click="goToDashboard">
            <ods-table-column prop="title"  sortable label="Gadget" width="350">
              <template slot-scope="scope">
                <ods-icon :name="getGadgetIcon(scope.row)" size="12"></ods-icon>
                <span style="margin-left: 10px">{{ scope.row.title }}</span>
              </template>
            </ods-table-column>
            <ods-table-column prop="dashboardIdentification" sortable  label="Dashboard"></ods-table-column>
          </ods-table>
        </div>
    </ods-module>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FormFilter from '../../forms/formFilter.vue'
import { HTTP_PLATFORM } from '../../../store/modules/http'
export default {
  name: 'ToolBarFilter',
  components: {
    FormFilter
  },
  props: {
    dynFilters: { type: Array, required: true },
    dashboardId: { type: String, required: true }
  },
  data () {
    return {
      // default values
      logControl: true,
      favoriteIsOpen: false,
      filterIsOpen: false,
      optionSelected: 'default',
      query: '',
      searchLoading: false,
      searchResults: false,
      searchIcon: 'search',
      searchTotalResults: 0,
      searchItems: []
    }
  },
  directives: {
    'click-outside': {
      bind: function (element, binding, vnode) {
        element.clickOutsideEvent = function (event) {
          // check that click was outside the el and his children
          if (!(element === event.target || element.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', element.clickOutsideEvent)
      },
      unbind: function (element) {
        document.body.removeEventListener('click', element.clickOutsideEvent)
      }
    }
  },
  methods: {
    toggleFavorite () {
      this.favoriteIsOpen = !this.favoriteIsOpen
      this.optionSelected = this.favoriteIsOpen ? 'favorite' : 'default'
      this.filterIsOpen = false
    },

    toggleFilter () {
      this.filterIsOpen = !this.filterIsOpen
      this.optionSelected = this.filterIsOpen ? 'filter' : 'default'
      this.favoriteIsOpen = false
    },

    // SEARCH GADGETS IN PROYECT (REALM) OR GENERIC
    async handleSearch () {
      try {
        if (this.logControl) { console.log('searchGadgets(): ', this.query) }
        if (!this.query || this.query.length < 3) { return false }
        // run search
        this.searchLoading = true
        const app = this.getCurrentApp
        const appProject = app.project || ''
        const searchApiEndPoint = '/api-manager/server/api/v1/gadgetFinder/findGadget/' + appProject + '/' + this.query + '/'
        this.searchIcon = this.searchLoading ? 'loading' : 'search'

        // TO-DO: 1º launch searching icon , 2º run query, 3º get results, 4º no-result icon or module zone with text, querystring and results, 5 reset icon to search
        const searchElements = await HTTP_PLATFORM.get(searchApiEndPoint, { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
        if (this.logControl) { console.log('searchGadgets() |--> Results', JSON.stringify(searchElements)) }
        this.searchLoading = false
        this.searchIcon = 'search'
        if (searchElements.data.length > 0) {
          this.searchResults = true
          this.searchTotalResults = searchElements.data.length
          // avoid duplicates
          // this.searchItems = searchElements.data
          this.searchItems = searchElements.data.filter((v, i, a) => a.findIndex(t => (t.dashboardId === v.dashboardId && t.title === v.title)) === i)
        } else {
          // search done, but no results
          this.searchLoading = false
          this.searchIcon = 'search'
          this.$notify({
            title: 'Buscador de Gadgets',
            message: 'No se han encontrado gadgets',
            type: 'warning',
            iconClass: 'ods-icon-search',
            duration: 2500,
            position: 'top-right',
            showClose: true
          })
          this.closeResults()
        }
      } catch (error) {
        console.log('ERROR CALLING SEARCH GADGETS', error)
        this.searchLoading = false
        this.searchIcon = 'search'
        return error
      }
    },

    closeResults () {
      // close results if open and click outside or close de search
      this.searchResults = false
      console.log('cerrando search results')
      this.$refs.searchBtn.inputValue = ''
      this.$refs.searchBtn.isExpanded = false
    },

    dragStartHandler (ev) {
      if (ev.dataTransfer) {
        ev.dataTransfer.setData('type', 'livehtml')
        ev.dataTransfer.dropEffect = 'copy'
      }
    },

    addData (item, e) {
      console.log('datatransfer...' + JSON.stringify(item))
      if (item.type !== 'livehtml') {
        e.dataTransfer.setData('gid', item.id)
        e.dataTransfer.setData('title', item.title)
        e.dataTransfer.setData('type', item.type)
      } else {
        e.dataTransfer.setData('gid', item.id)
        e.dataTransfer.setData('title', item.title)
        e.dataTransfer.setData('type', 'livehtml')
      }
    },
    addRawGadget (item, e) {
      e.dataTransfer.setData('title', item.title)
      e.dataTransfer.setData('type', 'livehtml')
      e.dataTransfer.setData('config', item.config)
    },

    saveDashboard () {
      if (this.dashboardId) {
        this.$parent.saveDashboard()
      }
    },

    goToDashboard (row) {
      console.log('seleccionando Fila de Busqueda: ' + JSON.stringify(row))
      if (row.dashboardId) {
        this.$router.push({ name: 'Dashboard', params: { dashboardId: row.dashboardId } })
        this.closeResults()
      }
    }
  },
  computed: {
    ...mapGetters({
      loginType: 'getLoginType',
      realm: 'getRealmInfo',
      getCurrentApp: 'getCurrentApp',
      getCurrentCustomization: 'getCurrentCustomization'
    }),
    isFavoritesEnabled () {
      const customization = this.getCurrentCustomization
      return customization.favorites.showFavorites === true
    },
    getGadgetIcon: function () {
      return function (row) {
        // TO-DO: apply others icons
        var gadgetType = row.type
        var icon = gadgetType === 'bar' ? 'chart-bar' : 'square-map'
        return icon
      }
    }
  },
  watch: {
    '$route.params.dashboardId': {
      // Watch for dashboard change, then init filter selectors
      immediate: true,
      handler (dashboardId) {
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.toolbar {
  display: flex; justify-content: space-between; width: 100%; height: rem(30);
  &__section {
    display: flex; align-items: center; flex-direction: row;
  }
}
.favorite {
  display:block;
  &--open {
    transition: all 0.4s ease;
  }
}
.filter {
  display:block;
  &--open {
    transition: all 0.4s ease;
  }
}
.gadgetFavorite {
  background-color: #2e6c99;
    padding: $space-050 16px;
    height: 24px;
    line-height: 14px;
    font-size: 9px;
    color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho,Helvetica Neue,Helvetica,Arial,sans-serif;
    font-weight: 500;
    letter-spacing: .2px;
    border: 1px solid;
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
}

.search-results {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 600px;
  height: 400px;
  z-index: 10;
  border-bottom: 0px !important;
  border-radius: 0px !important;
}

.subheader {
  border-bottom: 1px solid var(--color-border-hard-divisor);

  & ::v-deep .ods-input--search {
    flex-direction: row-reverse;
    padding-right: $space-050;
  }

  & ::v-deep .ods-input-search--is-clearable .ods-input__suffix {
    margin-right: rem(-32)
  }
}
::v-deep .ods-scrollbar__wrap--custom { height: 42px; background-color: #fff;  padding: 6px; }
::v-deep .ods-table__row { cursor: pointer!important }
::v-deep .ods-sub-header__main { width: 100% }
::v-deep .ods-sub-header { background: var(--color-bg-primary) }
</style>
